import React from 'react';

function ActivityPicker(props) {
    return (
        <div className={props.className + " activity-picker d-flex justify-content-between align-items-center"} onClick={props.onClick} id={props.id}>
            {props.children}
            <div>
                {props.icon}
            </div>
        </div>
    );
}

export default ActivityPicker;
